import React from "react";
import PreviewExperiences from "./PreviewExperiences";
import PreviewReferences from "./PreviewReferences";

function PreviewRightContainers({ contents }) {
  return (
    <>
      {contents.map((content) => {
        if (content.type === "experience") {
          return <PreviewExperiences key={content.id} experiences={content} />;
        } else if (content.type === "reference") {
          return <PreviewReferences key={content.id} references={content} />;
        }
      })}
    </>
  );
}

export default PreviewRightContainers;
